import React, {FC, useEffect, useState} from 'react'
import DialogContent from '@pixel/core/DialogContent'
import { useForm, FormProvider } from 'react-hook-form'
import {AutomationSearchResult} from '../types/Automations'
import {Alert, Snackbar} from "@mui/material";
import AutomationView from "./AutomationView";

interface AutomationViewContainerProps {
    selectedAutomation: AutomationSearchResult
    onModalClose: () => void
}

const AutomationViewContainer: FC<AutomationViewContainerProps> = ({
    selectedAutomation,
    onModalClose
}) => {

    const [formSubmitted, setFormSubmitted] = useState(false)
    const [formResponse, _setFormResponse] = useState(null)
    const [formMessage, _setFormMessage] = useState('')

    const form = useForm({
        defaultValues: {
            name: '',
            companyFilters: [
                {
                }
            ],
            companyActions: [
                {
                }
            ]
        },
    })

    useEffect(() => {
        if (Boolean(selectedAutomation)) {
            form.reset(selectedAutomation)
        }
    }, [selectedAutomation])

    return (
        <FormProvider {...form}>
            <Snackbar open={formSubmitted} autoHideDuration={1000} onClose={() => {
                setFormSubmitted(false)
                if (formResponse == 'success') {
                    onModalClose()
                }
            }}>
                <Alert onClose={() => setFormSubmitted(false)} severity={formResponse} sx={{ width: '100%' }}>
                    {formMessage}
                </Alert>
            </Snackbar>
            <DialogContent sx={{ padding: 0 }}>
                <AutomationView selectedAutomation={selectedAutomation} />
            </DialogContent>
        </FormProvider>
    )
}

export default AutomationViewContainer
